import { px2cm, px2mm, cm2px, mm2px } from '~src/utils/units';

export const convertToUnit = (sourceUnit, destUnit, sourceValue, dpi = 300) => {
  const value = parseFloat(sourceValue);

  const supportedUnits = ['cm', 'mm', 'px'];
  if (
    !supportedUnits.includes(sourceUnit) ||
    !supportedUnits.includes(destUnit)
  ) {
    throw new Error('Measuring unit not supported');
  }

  const unitToConverter = {
    cm2px: cm2px,
    cm2mm: (value) => value * 10,
    cm2cm: (value) => value,
    mm2px: mm2px,
    mm2cm: (value) => value / 10,
    mm2mm: (value) => value,
    px2cm: px2cm,
    px2mm: px2mm,
    px2px: (value) => value,
  };
  const key = `${sourceUnit}2${destUnit}`;
  const converterFunc = unitToConverter[key];
  const convertedValue = converterFunc(value, dpi);

  return Math.round(convertedValue * 100) / 100;
};
